import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom"

import { useTranslation } from "react-i18next";

import logo from "../img/logo.png"

function MobileMenu() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const location = useLocation();

    const { t } = useTranslation();

    return (
        <div>
            <div className="relative z-[999] w-[30px] h-[10px] cursor-poroboto flex flex-col justify-between xl::hidden" onClick={toggleMenu}>
                <div className={`w-full h-[1px] transition duration-300 transform ${isOpen ? 'rotate-45 translate-y-[8px] bg-[#000] w-[35px]' : 'bg-[#0C2780]'}`}></div>
                <div className={`w-full h-[1px]  transition duration-300 transform ${isOpen ? '-rotate-45 -translate-y-[1px] bg-[#000] w-[35px]' : 'bg-[#0C2780]'}`}></div>
            </div>
            <div className={`fixed top-0 right-0 bottom-0 w-full md:w-1/2 bg-white z-50 transform transition-all duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                <div className="flex flex-col items-center mt-[50px] gap-[15px]">
                    <img src={logo} alt="" className="w-[80px]"/>
                    <Link to="/markets-crypto"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/markets-crypto' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.2.1')}</p></Link>
                    <Link to="/products-arvest"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/products-arvest' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.2.2')}</p></Link>
                    <Link to="/markets-crypto"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/markets-crypto' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.2.3')}</p></Link>
                    <Link to="/products-arvest"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/products-arvest' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.2.4')}</p></Link>
                    <Link to="/stock"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/stock' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.2.5')}</p></Link>
                    <Link to="/premium-service"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/premium-service' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.3.1')}</p></Link>
                    <Link to="/trade-terminal"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/trade-terminal' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.3.2')}</p></Link>
                    <Link to="/accounts"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/accounts' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.4')}</p></Link>
                    <Link to="/about"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/about' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.5')}</p></Link>
                    <Link to="/academy"><p className={`text-[18px] manrope text-[#0C2780] ${location.pathname === '/academy' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.6')}</p></Link>
                    <a href="https://user.arvest-solid.net">
                        <div className="button cursor-poroboto">
                            <p className="roboto text-white text-[18px]">{t('header.button')}</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;